import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../api/api-context';

/**
 * First sign-in step (spec v1.2): an account without a username chooses one before
 * using the app. AppShell renders this in place of the page; saving updates the
 * shared `['profile']` query, which lifts the gate and shows the requested page.
 */
export function UsernameOnboarding(): JSX.Element {
  const api = useApi();
  const queryClient = useQueryClient();
  const [username, setUsername] = useState('');
  const save = useMutation({
    mutationFn: () => api.updateProfile(username.trim()),
    onSuccess: (data) => queryClient.setQueryData(['profile'], data),
  });

  return (
    <main className="profile-page onboarding-page">
      <section className="panel" aria-labelledby="onboarding-title">
        <p className="eyebrow">WELCOME</p>
        <h1 id="onboarding-title">Choose your username</h1>
        <p className="hint">This is how you appear in ItsAllPrep. You can change it later in your profile.</p>
        <form className="profile-form" onSubmit={(event) => { event.preventDefault(); save.mutate(); }}>
          <label htmlFor="onboarding-username">Username</label>
          <input id="onboarding-username" autoComplete="username" required minLength={3} maxLength={24}
            pattern="[a-zA-Z][a-zA-Z0-9_]{2,23}" value={username} disabled={save.isPending}
            onChange={(event) => { setUsername(event.target.value); save.reset(); }} />
          <p className="hint">3–24 letters, numbers or underscores. Start with a letter.</p>
          <button className="studio-primary" disabled={save.isPending} type="submit">
            {save.isPending ? 'Saving…' : 'Continue'}
          </button>
          {save.isError && <p role="alert">{save.error.message}</p>}
        </form>
      </section>
    </main>
  );
}
